// The site theme: kast-common's family themes (System, Light, Dark and High
// contrast) on its shared palettes, with the site's accent from index.css.
// index.html runs themeBootScript(themeConfig) before first paint, so the
// page never flashes the wrong theme (a test keeps the two in step).

import { createThemeStore, FAMILY_THEME_CONFIG, type ThemeConfig } from "@jkast90/kast-common/theme";

export const themeConfig: ThemeConfig = { storageKey: "admin_theme", ...FAMILY_THEME_CONFIG };

export const themeStore = createThemeStore(themeConfig);
